
const oncoRiskConfig = {

  
    // API endpoints
    api: {
      baseUrl: 'https://service9002.szapfs.org',
      endpoints: {
        webserverCookie: '/webserver_cookie',
        uploads: '/outputs',

  
      }
    },
  

      
      

  };
  

  export function getItemById(id) {
    return oncoRiskConfig.items[id] || null;
  }
  
  export function getSidebarGroups() {
    return oncoRiskConfig.groups.map(group => ({
      ...group,
      items: group.items.map(itemId => ({
        id: itemId,
        ...oncoRiskConfig.items[itemId]
      }))
    }));
  }
  
  export function getApiBaseUrl() {
    return oncoRiskConfig.api.baseUrl;
  }
  
  export function getApiEndpoint(endpoint) {
    const baseUrl = oncoRiskConfig.api.baseUrl;
    const path = oncoRiskConfig.api.endpoints[endpoint];
    return `${baseUrl}${path}`;
  }
  

  
  
  
  export default oncoRiskConfig;
  